import { render, staticRenderFns } from "./PciList.vue?vue&type=template&id=05cc69a2"
import script from "./PciList.vue?vue&type=script&lang=js"
export * from "./PciList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports